import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const PASTOR_NAME = "Chief Apostle Leonard Lucas Jr.";
export const SITE_NAME = "Chief Apostle Leonard Lucas Jr. Masterclass";

export const MASTERCLASS_BANNER =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_pastor-brand-hub/artifacts/ovuo9i7p_A146182F-582C-4D1E-93F2-364E4F2E4E56.png";
export const SQUARE_PAYMENT_LINK = "https://square.link/u/2pLDZr4K";
export const REGISTRATION_FEE = 205;

export const CAROUSEL = [
  "https://customer-assets.emergentagent.com/job_pastor-brand-hub/artifacts/b2zc148p_656998253_26843347238595814_8709749448237442614_n.webp",
  "https://customer-assets.emergentagent.com/job_pastor-brand-hub/artifacts/wqcmhvl3_498643154_24110773598519872_3491879207667876702_n.webp",
  "https://customer-assets.emergentagent.com/job_pastor-brand-hub/artifacts/q3c8ht7o_498124494_24110484778548754_6905403328170131226_n.webp",
  "https://customer-assets.emergentagent.com/job_pastor-brand-hub/artifacts/ox3dggbe_89697688_3149288958428308_4043847653488852992_n.jpg",
  "https://customer-assets.emergentagent.com/job_pastor-brand-hub/artifacts/avy4z959_654294415_26800679012862637_9037092234213264857_n.jpg",
];

export const IMAGES = {
  heroPortrait: CAROUSEL[0],
  community:
    "https://images.unsplash.com/photo-1681641095463-b4d3693a0ee3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxjb21tdW5pdHklMjBnYXRoZXJpbmclMjB3YXJtJTIwbGF1Z2hpbmd8ZW58MHx8fHwxNzgzNDUxOTg2fDA&ixlib=rb-4.1.0&q=85",
  devotional:
    "https://images.unsplash.com/photo-1677846092922-5b685ba0afb2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHx3YXJtJTIwbW9ybmluZyUyMGxpZ2h0JTIwcmVhZGluZyUyMGNvZmZlZXxlbnwwfHx8fDE3ODM0NTE5ODZ8MA&ixlib=rb-4.1.0&q=85",
};
